import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Popup from './';
import { getCookie } from '../../helpers/cookie';

class ComplaintPopup extends Component {
  static propTypes = {
    // route: PropTypes.string.isRequired,
    commentId: PropTypes.number,
  };

  state = {
    sendData: false,
    error: null,
    success: false,
    type: this.props.type,
    filmBitrixId: this.props.filmId,
    commentPremierId: this.props.commentId,
    commentAuthor: this.props.commentAuthor,
    commentText: this.props.filmText,
    userId: getCookie('USER_ID'),
  };

  confirm = async e => {
    e.preventDefault();
    const {
      type,
      filmBitrixId,
      commentPremierId,
      commentAuthor,
      commentText,
      userId,
    } = this.state;

    const route = '/local/php_interface/api/v2/review/complain/';

    const data = {
      type,
      filmBitrixId,
      commentPremierId,
      commentAuthor,
      commentText,
      userId,
    };

    const headers = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {},
    };

    // if (process.env.NODE_ENV != 'dev') {
    // 	headers.credentials = 'include';
    // }

    this.setState({
      sendData: true,
      error: null,
    });

    try {
      const response = await fetch(route, headers);
      if (response.status === 200) {
        this.setState({
          sendData: false,
          error: null,
          success: true,
        });
      } else {
        this.setState({
          sendData: false,
          error: true,
        });
      }
    } catch (error) {
      this.setState({
        sendData: false,
        error: true,
      });
    }
  };

  render() {
    const { sendData, error, success, type } = this.state;

    if (success)
      return (
        <Popup
          type="alert"
          status="success"
          title="Спасибо!"
          message="Мы проверим ваше обращение и примем меры."
          button="Назад"
        />
      );

    if (error)
      return (
        <Popup
          type="alert"
          status="error"
          title="Ошибка!"
          message="Так и до тёмной стороны не далеко. Попробуйте еще раз."
          button="Назад"
        />
      );

    let btnClasses = ['btn'];

    if (sendData) btnClasses.push('btn--loading');

    return (
      <div className="popup complaint-popup">
        <form className="popup__content">
          <div className="popup__content-inner">
            <div className="popup__section-title">
              <h3 className="heading heading--1 popup__title">
                {type == 'spam'
                  ? 'Спам'
                  : type == 'abuse'
                  ? 'Оскорбление'
                  : 'Нецензурная речь'}
              </h3>
            </div>
            <p className="popup__text">
              {type == 'spam'
                ? 'Реклама в не предназначенных для этого местах — за такое можем и заблокировать пользователя.'
                : type == 'abuse'
                ? 'Унижение чести и достоинства — выражение своего мнения не должно затрагивать личности.'
                : 'Использование ненормативной лексики при описании своих эмоций от просмотра.'}
            </p>
            <div className="popup__btn-wrap">
              {error ? <p>{error}</p> : null}
              <div className="wrap">
                <a
                  className="btn btn--outline"
                  onClick={() => $.magnificPopup.close()}
                >
                  Отменить
                </a>
                <button className={btnClasses.join(' ')} onClick={this.confirm}>
                  Пожаловаться
                </button>
              </div>
            </div>
          </div>
        </form>
        <button className="popup__close" type="button">
          <svg viewBox="0 0 18 18" width="18" height="18">
            <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z"></path>
          </svg>
        </button>
      </div>
    );
  }
}

export default ComplaintPopup;
